/**
 * @module User´s Friendships
 * @since 3.78.0
 * @author Jacob Viertel <jv@onscreen.net>
 *
 * Provides the friendships and updates to the friendships of the `AuthUser`.
 *
 * @example
 * ```js
 * // Get the friendship state for the `amateur`
 * const friendship = getFriendship(amateur.id);
 *
 * // Observe friendship changes
 * ctxFriendship.observe(element, (friendship) => {
 *   console.log('friendship changed', friendship);
 * });
 *
 * // Observe the list of confirmed friends
 * ctxFriends.observe(element, (friends) => {
 *   console.log('confirmed friends changed', friends);
 * });
 *
 * ```
 */

import {GlobalContext} from '@acng/frontend-relativity';

/**
 * Provides `friendship` updates or `null` when many friendships changed.
 *
 * @type {Global<Valid<typeof import("../model/friendship.js").FRIENDSHIP> | null>}
 */
export const ctxFriendship = GlobalContext(null);
